import React from 'react';
import PropTypes from 'prop-types';

import './module-header.scss';

const ModuleHeader = ({
  text,
  title,
  withMobileLogo,
  error,
}) => (
  <div className='module-header'>
    <div className='module-header__wrapper'>
      <h1 className='module-header__title'>{title}</h1>
      {withMobileLogo && <img className='module-header__icon' src='/logos/logo-header.svg' alt='Cemetery logo'/>}
    </div>
    <p className={`module-header__text ${error ? 'module-header__text_error' : ''}`}>{text}</p>
  </div>
);

ModuleHeader.defaultProps = {
  error: false,
  text: '',
  title: '',
  withMobileLogo: false,
};

ModuleHeader.propTypes = {
  error: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
  withMobileLogo: PropTypes.bool,
};

export default ModuleHeader;
